import { createContext } from 'react'
import type { ConsentCategories, ConsentState, Jurisdiction } from './consentTypes'

export interface ConsentContextValue {
  /** True once `/public-config` has resolved (jurisdiction is known). */
  isReady: boolean
  /** Effective jurisdiction (undefined until ready). */
  jurisdiction: Jurisdiction | undefined
  /** Current policy version from the server. */
  policyVersion: string | undefined
  /** Browser Global Privacy Control signal (absolute opt-out when true). */
  gpc: boolean
  /** Effective (current-version) consent decision, or null if none/stale. */
  consent: ConsentState | null
  /**
   * Whether the user has a valid current acknowledgment. Until this is true the
   * app is not rendered and NO first-party cookies / storage are written
   * (RQ10773473) — a focus-trapping blocking modal is shown instead (RQ10409305).
   */
  acknowledged: boolean
  /** Whether the preferences modal is open. */
  isSettingsOpen: boolean
  /** Whether a given non-necessary category is effectively permitted right now. */
  isCategoryAllowed: (
    category: 'functional' | 'analytics' | 'marketing'
  ) => boolean
  acceptAll: () => void
  rejectNonEssential: () => void
  savePreferences: (cats: ConsentCategories) => void
  openSettings: () => void
  closeSettings: () => void
}

export const ConsentContext = createContext<ConsentContextValue | null>(null)
